/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Input } from 'semantic-ui-react'

const AddTyreRun = ({
  field: { name, value },
  form: { touched, errors, setFieldValue },
  ...props
}) => {

  useEffect(() => {
  }, [])

  return (
    <>
      <Input
        onChange={(value, data) => {
          setFieldValue(name, data.value)
          if (props?.setFlag) {
            setFieldValue(props.setFlag, 1)
          }
        }}
        type='number'
        className="width-100cent"
        placeholder="Enter Tyre Run.." />
    </>
  )
}

export default AddTyreRun